// extracted by mini-css-extract-plugin
module.exports = {"u_skip":"InsuranceLayout_u_skip__3KlOi","blind":"InsuranceLayout_blind__JTBpE","hidden":"InsuranceLayout_hidden__2ECkO","article":"InsuranceLayout_article__9SVVd"};